import DynamicSectionElement from "@/scripts/dynamic-section-element.js";
import { setRecentlyViewed } from "@/scripts/recently-viewed";
import CustomDetails from "../details/details";
import { Notyf } from "notyf";
import "notyf/notyf.min.css";
import { root } from "postcss";

const notyf = new Notyf({
  position: {
    x: "right",
    y: "top",
  },
  types: [
    {
      type: "success",
      background: "rgb(6, 95, 70)",
      duration: 5000,
      dismissible: true,
    },
    {
      type: "error",
      background: "indianred",
      duration: 5000,
      dismissible: true,
    },
  ],
});

function initializeShareLink() {
  const customer_info = document.querySelector("[data-id-c]");
  if (!customer_info) {
    return;
  }

  const secure_url = customer_info.getAttribute("data-url");
  const customer_id = customer_info.getAttribute("data-id-c");
  const product_url = customer_info.getAttribute("data-product");
  const ok = customer_info.getAttribute("data-ok");

  /*
  const referralUrl = secure_url + product_url + "?av_ref_id=" + customer_id;
  let shareLink = document.getElementById("share-link");
  if (!shareLink) {
    return;
  }

  shareLink.addEventListener("click", (e) => {
    e.preventDefault();
    navigator.clipboard
      .writeText(referralUrl)
      .then(() => notyf.success(ok))
      .catch((error) => console.log("Error copying", error));
  });
  */
}

class ProductMain extends DynamicSectionElement {
  constructor() {
    super();

    this.details_wrapper = this.querySelector('div[data-slot="details"]');
    this.details = this.details_wrapper.querySelectorAll("custom-details");
    // Replace dynamic product content when changing variant options
    this.addEventListener("change-variant", (event) => {
      const { origin, pathname } = window.location;
      const params = new URLSearchParams({
        variant: event.detail.id,
      });

      this.loadSectionFromUrl(`${origin}${pathname}?${params}`, {
        replaceState: true,
      });

      //console.log(variant_json[event.detail.id]);
    });

    this.addEventListener("detail-opend", (event) => {
      this.details.forEach((detail) => {
        if (detail.id != event.detail.id) {
          detail.close();
        }
      });
    });

    setRecentlyViewed(this.dataset.handle);
    this.details_wrapper.classList.replace("opacity-0", "opacity-1");
  }
}

customElements.define("custom-details", CustomDetails);
customElements.define("product-main", ProductMain);

class CustomA extends HTMLElement {
  constructor() {
    super();

    this.to = this.getAttribute("to");

    this.addEventListener("click", this.goTo);
  }

  goTo() {
    let ele = document.querySelector(this.to);
    function getPos(ele) {
      console.log(ele);
      var y = 0;
      while (true) {
        y += ele.offsetTop;
        if (ele.offsetParent === null) {
          break;
        }
        ele = ele.offsetParent;
      }
      return y;
    }
    window.scrollTo({ top: getPos(ele) - 400, behavior: "smooth" });
  }
}

customElements.define("custom-a", CustomA);

class customCartButton extends HTMLElement {
  constructor() {
    super();

    let mobile = window.matchMedia("(max-width: 768px)").matches;
    let wrapper =
      this.parentElement.getElementsByTagName("custom-cart-button")[0];
    this.customButton = this.querySelector("#custom-cart-button");
    this.productForm =
      this.parentElement.getElementsByTagName("product-form")[0];
    let customily = false;
    let rootMargin = mobile ? "-55px 0px 0px 0px" : "-121px 0px 0px 0px";
    this.customilyHook = this.customilyHook.bind(this);
    if (
      document.querySelector("product-main").getAttribute("customily") ===
      "true"
    ) {
      customily = true;
      this.customButton.classList.add("show-animation");
    }
    this.primaryButton = customily
      ? this.productForm.querySelector("#customily-cart-btn")
      : this.productForm.querySelector("#cart-submit-button");

    this.customButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.primaryButton?.click();
      if (customily) {
        this.customButton.classList.add("show-animation");
      }
    });

    wrapper.classList.remove("animate");

    function toggleCustomButton(isIntersecting) {
      if (isIntersecting) {
        wrapper.classList.remove("animate");
        document.body.classList.remove("chat-move-position");
      } else {
        wrapper.classList.add("animate");
        document.body.classList.add("chat-move-position");
      }
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const bcr = entry.boundingClientRect;
          const isBottomVisible = bcr.bottom < window.innerHeight && bcr.bottom;
          if (isBottomVisible != false) {
            toggleCustomButton(entry.isIntersecting);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: rootMargin,
      }
    );

    this.mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList" || mutation.type === "attributes") {
          if (!customily) {
            this.primaryButton = this.productForm.querySelector(
              "#cart-submit-button"
            );
          }
          this.observer.unobserve(this.primaryButton);
          this.observer.observe(this.primaryButton);
        }
      });
    });

    if (!customily) {
      this.observer.observe(this.primaryButton);
      this.mutationObserver.observe(this.productForm, {
        childList: true,
        subtree: true,
        attributes: true,
      });
    }
  }

  customilyHook(button) {
    this.primaryButton = button;
    this.customButton.classList.remove("show-animation");
    this.observer.observe(this.primaryButton);
    this.mutationObserver.observe(this.productForm, {
      childList: true,
      subtree: true,
      attributes: true,
    });
  }
}

customElements.define("custom-cart-button", customCartButton);

initializeShareLink();
